// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2n4KM","colMaxWidth":"Table_colMaxWidth__2sQDf"};